/**
 * Données fictives pour la prévisualisation des templates
 */

import { InvoiceData, QuoteData, InvoiceItem } from '@/components/templates/types';

// Société fictive pour la prévisualisation
export const mockCompany = {
  id: 'preview-company',
  legalName: 'Entreprise Démo SARL',
  tradeName: 'Entreprise Démo',
  email: 'contact@entreprise-demo.fr',
  phone: '01 23 45 67 89',
  addressLine1: '123 Avenue des Champs-Élysées',
  city: 'Paris',
  zipCode: '75008',
  countryCode: 'FR',
  vatNumber: 'FR12345678901',
  registrationNumber: '123 456 789 00012',
  logoUrl: null,
  legalForm: 'SARL',
  capital: '50000',
  rcsCity: 'Paris',
  rcsNumber: 'Paris B 123 456 789',
  apeCode: '6201Z',
  iban: 'FR76 1234 5678 9012 3456 7890 123',
  bic: 'BNPAFRPP',
};

// Items fictifs
const mockItems: InvoiceItem[] = [
  {
    description: 'Développement site web vitrine',
    unitPrice: 2500,
    quantity: 1,
    total: 2500,
    vatRate: 20,
    vatAmount: 500,
  },
  {
    description: 'Hébergement annuel Premium',
    unitPrice: 150,
    quantity: 12,
    total: 1800,
    vatRate: 20,
    vatAmount: 360,
  },
  {
    description: 'Maintenance mensuelle',
    unitPrice: 200,
    quantity: 6,
    total: 1200,
    vatRate: 20,
    vatAmount: 240,
  },
  {
    description: 'Formation utilisateur (2h)',
    unitPrice: 150,
    quantity: 2,
    total: 300,
    vatRate: 20,
    vatAmount: 60,
  },
];

// Calcul des totaux
const subtotal = mockItems.reduce((sum, item) => sum + item.total, 0);
const tax = mockItems.reduce((sum, item) => sum + (item.vatAmount || 0), 0);
const total = subtotal + tax;

// Facture fictive
export const mockInvoiceData: InvoiceData = {
  id: 'preview-invoice',
  invoiceNumber: 'FA-2025-0042',
  issueDate: new Date().toISOString().split('T')[0],
  dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
  clientName: 'Jean Dupont',
  clientCompany: 'Dupont & Associés',
  clientAddressLine1: '45 Rue de la Paix',
  clientCity: 'Lyon',
  clientZipCode: '69002',
  clientCountryCode: 'FR',
  clientPhone: '04 78 12 34 56',
  clientEmail: 'jean.dupont@example.com',
  items: mockItems,
  subtotal,
  tax,
  total,
  notes: 'Merci pour votre confiance. Paiement sous 30 jours.',
  status: 'SENT',
};

// Devis fictif
export const mockQuoteData: QuoteData = {
  id: 'preview-quote',
  quoteNumber: 'DV-2025-0018',
  issueDate: new Date().toISOString().split('T')[0],
  validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
  clientName: 'Marie Martin',
  clientCompany: 'Martin Consulting',
  clientAddressLine1: '78 Boulevard Haussmann',
  clientCity: 'Paris',
  clientZipCode: '75009',
  clientCountryCode: 'FR',
  clientPhone: '01 42 65 78 90',
  clientEmail: 'marie.martin@example.com',
  items: mockItems,
  subtotal,
  tax,
  total,
  notes: 'Devis valable 30 jours. Acompte de 30% à la commande.',
  status: 'DRAFT',
};
